// Referential stability for derived store getters.
//
// React's useSyncExternalStore compares getSnapshot results by identity, and
// zustand v5's `useStore` passes the selector straight through with no equality
// function. So a getter that allocates a fresh array/object per call re-renders
// forever ("The result of getSnapshot should be cached to avoid an infinite
// loop"). Every getter reachable from a `useStore` selector must return the same
// reference until its inputs actually change.
//
// One cache slot per memo, so these belong inside a store factory — never at
// module scope, where two store instances would share (and thrash) the slot.
// Memoize on the identity of a slice. Reconcile replaces the whole slice object on
// every change, so the slice reference is a sound cache key.
export const memoizedOverSlice = (derive) => {
    let lastSlice = null;
    let lastOut = null;
    return (s) => {
        if (s !== lastSlice) {
            lastSlice = s;
            lastOut = derive(s);
        }
        return lastOut;
    };
};
// Memoize on a tuple of state fields, compared by identity (Object.is). For stores
// that hold plain arrays rather than a reconcile slice: the getter recomputes only
// when one of the fields it reads is replaced.
export const memoizedOnDeps = (read, derive) => {
    let lastDeps = null;
    let lastOut = null;
    return () => {
        const deps = read();
        if (lastDeps === null || deps.some((d, i) => !Object.is(d, lastDeps[i]))) {
            lastDeps = deps;
            lastOut = derive(deps);
        }
        return lastOut;
    };
};
//# sourceMappingURL=memo.js.map